<template>
    <v-app id="app">
        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>
        <!-- Footer -->
        <page-footer />
    </v-app>
</template>
<script>
import PageFooter from "../components/page-footer.vue";

export default {
    components: { PageFooter },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
    computed: {}
};
</script>

<style scoped></style>
